import YogaStagePage from "./YogaStagePage";
import RestaurantsStagePage from "./RestaurantsStagePage";
import GymnasiumStagePage from "./GymnasiumStagePage";
import BasketballStagePage from "./BasketballStagePage";
import SwimmingStagePage from "./SwimmingStagePage";
import WalkingStagePage from "./WalkingStagePage";
import SupermarketStagePage from "./SupermarketStagePage";

export const stagePageComponents = {
  yoga: YogaStagePage,
  restaurants: RestaurantsStagePage,
  gymnasium: GymnasiumStagePage,
  basketball: BasketballStagePage,
  swimming: SwimmingStagePage,
  walking: WalkingStagePage,
  supermarket: SupermarketStagePage,
};
